import React, { createContext, useContext, useEffect, useState } from 'react'

const STORAGE_KEY = 'retroMode'

const RetroModeContext = createContext({
  retroMode: false,
  toggleRetroMode: () => {},
})

export const RetroModeProvider = ({ children }) => {
  const [retroMode, setRetroMode] = useState(
    () => window.localStorage.getItem(STORAGE_KEY) === 'true',
  )

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, String(retroMode))
  }, [retroMode])

  const toggleRetroMode = () => setRetroMode((current) => !current)

  return (
    <RetroModeContext.Provider value={{ retroMode, toggleRetroMode }}>
      {children}
    </RetroModeContext.Provider>
  )
}

export const useRetroMode = () => useContext(RetroModeContext)
